module.exports = __webpack_public_path__ + "img/iconservice2.46b1c511.png";